import React from 'react';

/**
 * Panel - Structured container component
 * FLO Design System v2
 */
export const Panel = ({ children, className = '', noPadding = false, onClick, ...rest }) => {
  return (
    <div
      className={`bg-white border border-gray-200 rounded-lg ${!noPadding ? 'p-3' : ''} ${className}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
};

/**
 * Section - Title + content wrapper
 */
export const Section = ({ title, action, children, tight = false }) => {
  return (
    <div>
      {title && (
        <div className={`flex items-center justify-between ${tight ? 'mb-2' : 'mb-3'}`}>
          <h3 className="text-sm font-medium text-gray-900">{title}</h3>
          {action}
        </div>
      )}
      {children}
    </div>
  );
};

export default Panel;
